import { Construction } from 'lucide-react';

export function PlaceholderPage({ title, description }: { title: string; description?: string }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-5 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-50 text-brand-600 dark:bg-brand-900/40 dark:text-brand-300">
        <Construction size={22} />
      </div>
      <div className="max-w-md">
        <h1 className="font-display text-[26px] font-bold tracking-tight text-ink">{title}</h1>
        <p className="mt-2 text-[14px] text-ink-mute">
          {description ?? 'Este módulo se desarrollará en la Fase 1 del plan. Aquí llegarán las tablas, formularios y reportes específicos.'}
        </p>
      </div>
      <span className="rounded-full border border-border bg-surface px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-mute">
        En construcción · F1
      </span>
    </div>
  );
}
